import { useEffect, useState } from 'react';

interface WaitForVideoProps {
  video: HTMLVideoElement;
}

export const useWaitForVideo = ({ video }: WaitForVideoProps) => {
  const [videoLoaded, setVideoLoaded] = useState<boolean>(false);

  useEffect(() => {
    let id: NodeJS.Timeout | undefined = undefined;

    if (video) {
      video.onloadeddata = () => {
        id = setTimeout(() => {
          setVideoLoaded(true);
        }, 1000);
      };
    }

    return () => {
      if (id) {
        clearTimeout(id);
      }
    };
  }, [video]);

  return [videoLoaded];
};
